import { render, staticRenderFns } from "./logisInboundRegisterV0.vue?vue&type=template&id=1e067c3a&scoped=true"
import script from "./logisInboundRegisterV0.vue?vue&type=script&lang=js"
export * from "./logisInboundRegisterV0.vue?vue&type=script&lang=js"
import style0 from "./logisInboundRegisterV0.vue?vue&type=style&index=0&id=1e067c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e067c3a",
  null
  
)

export default component.exports